import { notifications } from '@mantine/notifications';

export const MyNotifications = ({text, color, icon}:{text:string, color:string, icon:React.ReactNode}) => {
	notifications.show({ title: "SalonTeq", message: text, color: color,
		autoClose: 5000, withBorder: true, icon: icon, radius:'md',
	})
}

export default MyNotifications